export default {
    data: () => ({
        translations: {
            title: {
                el: "Κουπόνια με συναλλαγές",
                en: "Coupons With Transactions",
                it: "Buoni con transazioni"
            },
            info: {
                el: "Επιβράβευσε τους πελάτες σου με ένα κουπόνι όταν κάνουν έναν συγκεκριμένο αριθμό συναλλαγών στο κατάστημά σας",
                en:
                    "Reward your clients with a coupon when they do a certain amount of transactions at your stores",
                it: "Premiate i vostri clienti con un coupon quando fanno una certa quantità di transazioni nei vostri negozi"
            },
            description: {
                el: "Επιβράβευσε τους πελάτες σου βάση συχνότητας επισκέψεων ή δαπανημένου ποσού σε αγορές στο κατάστημά σου.",
                en: "Reward your customers based on the frequency of visits or the amount spent at your store.",
                it: "Premia i tuoi clienti in base alla frequenza delle visite o all'importo speso per gli acquisti nel tuo negozio."
            },
            descriptionBold: {
                el: "Ο κωδικός κουπονιού που αποκτά ο κάθε πελάτης διαρκεί 25 ημέρες (από την ημ/νία απόκτησης), ανεξαρτήτως της ημ/νίας λήξης του κουπονιού.",
                en: "The coupon code that each customer obtains lasts 25 days (from the date of acquisition), regardless of the expiration date of the coupon.",
                it: "Il codice coupon che ogni cliente ottiene ha una durata di 25 giorni (dalla data di acquisizione), indipendentemente dalla data di scadenza del coupon."
            },
            firstCardTitle: {
                el: "Στόχος Πελάτη",
                en: "Clients Goal",
                it: "Obiettivo del cliente"
            },
            firstCardSubtitle: {
                el: "Ορίστε τις συνθήκες για να κερδίσει ο πελάτης το κουπόνι.",
                en: "Specify the conditions for your customers to earn this coupon.",
                it: "Imposta le condizioni affinché il cliente possa vincere il coupon."
            },
            numberOfVisits: {
                el: "Αριθμός επισκέψεων",
                en: "Number of visits",
                it: "Numero di visite"
            },
            minTransaction: {
                el: "Ελάχιστο ποσό συναλλαγής",
                en: "Minimum transaction value",
                it: "Importo minimo della transazione"
            },
            maxDays: {
                el: "Ημέρες ισχύος κουπονιού",
                en: "Coupon validity days",
                it: "Giorni di validità del coupon"
            },
            secondCardTitle: {
                el: "Κουπόνι Επιβράβευσης",
                en: "Coupon for reward",
                it: "Buoni fedeltà"
            },
            secondCardSubtitle: {
                el: "Ορίστε τα στοιχεία του δώρου που αντιστοιχεί στο κουπόνι.",
                en: "Specify the details of the gift won from this coupon.",
                it: "Inserisci i dettagli del regalo che corrisponde al coupon."
            },
            giftTitle: {
                el: "Όνομα Δώρου",
                en: "Gift Title",
                it: "Nome del regalo"
            },
            giftDescription: {
                el: "Περιγραφή Δώρου",
                en: "Gift Description",
                it: "Descrizione del regalo"
            },
            maximum: {
                el: "Μέγιστος αριθμός κουπονιών",
                en: "Maximum amount of coupons",
                it: "Numero massimo di buoni"
            },
            selectCategory: {
                el: "Επιλογή Κατηγορίας",
                en: "Select Category",
                it: "Selezione della categoria"
            },
            uploadCoupon: {
                el: "Επισύναψη Φωτογραφίας ",
                en: "Upload Coupon Image",
                it: "Carica foto"
            },
            create: {
                el: "Δημιουργία Κουπονιού",
                en: "Create",
                it: "Creazione di coupon"
            },
            transactionType: {
                el: "Τύπος Επιβράβευσης",
                en: "Reward Type",
                it: "Tipo di Ricompensa"
            },
            totalAmount: {
                el: "Συνολικές δαπάνες που απαιτούνται (ποσό)",
                en: "Total spending required (amount)",
                it: "Spesa totale richiesta (importo)"
            }
        }
    })
};
